import CommonModal from '../../utils/common.modal'

// import Modal from './Modal'
import Confirm from './Confirm'

const ModalPlugin = {
  install (Vue, option = {}) {
    // new CommonModal 时的 第二个参数 目前没有地方用
    const commonModal = new CommonModal(Vue, {})

    Vue.prototype.$gkConfirm = {
      create (props, $on = {}) {
        const layerProps = {
          componentName: 'confirm',
          layer: false
        }
        let instance = commonModal.createLayer(Confirm, {
          ...option,
          ...props
        }, layerProps, $on)

        instance.show()

        return instance
      }
    }
  }
}

export default ModalPlugin
